// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__X8iHF","requiredAsterisk":"Info_requiredAsterisk__rsIvj"};